import styles from "../../../pages/ordermanager/Orders.module.css";

const AdvanceAmountModalInfo = ({ mode, data = [], totalAmount }) => {
  const total = Number(totalAmount || 0);
  // const totalAmount = Number(data?.[0]?.totalAmount || 0);

  // Only count received payments
  const paidAmount = data.reduce((sum, item) => {
    return item?.status?.toLowerCase() === "received"
      ? sum + Number(item?.paymentAmount || 0)
      : sum;
  }, 0);

  const pendingAmount = Math.max(total - paidAmount, 0);

  const li1Styles = {
    backgroundColor: mode ? "#2C2E33" : "",
    color: mode ? "#FFFFFF" : "#646B88",
    fontWeight: "600",
    gridTemplateColumns: "0.8fr 1fr 1fr 1fr 1fr 1fr",
    position: "sticky",
    top: 0,
    zIndex: 1,
  };

  const li2Styles = {
    backgroundColor: mode ? "#1B1D21" : "#FFFFFF",
    gridTemplateColumns: "0.8fr 1fr 1fr 1fr 1fr 1fr",
  };

  const summaryStyles = {
    backgroundColor: mode ? "#2C2E33" : "#D9DCE5",
    color: mode ? "#FFFFFF" : "#646B88",
    fontWeight: "500",
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    padding: "12px",
    marginTop: "10px",
    borderRadius: "6px",
  };

  const formatDateTime = (date, time) => {
    if (!date) return "-";

    const [day, month, year] = date.split("-");

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    return `${Number(day)} ${months[Number(month) - 1]} ${time || ""}`;
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "received":
        return "#22C55E"; // Green
      case "pending":
        return "#F59E0B"; // Orange
      default:
        return "#EF4444"; // Red
    }
  };

  return (
    <div
      className={`${styles.s_c_m} ${
        mode ? styles.dealer_address_modal_dark : ""
      }`}
    >
      <div className={styles.item_properties}>
        <p className={styles.header}>Amount Details</p>

        <ul className={styles.data_list}>
          {/* Header */}
          <li style={li1Styles}>
            <div>Receipt ID</div>
            <div>Date & Time</div>
            <div>Payment Type</div>
            <div>Payment Method</div>
            <div>Amount</div>
            <div>Status</div>
          </li>

          {/* Scrollable Data Section */}
          <div
            className={styles.item_properties_scroll}
            style={{
              maxHeight: "350px",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {data?.length > 0 ? (
              data.map((item) => (
                <li style={li2Styles} key={item?._id}>
                  <div>{item?.receiptId || "-"}</div>
                  <div>
                    {formatDateTime(item?.receiptDate, item?.receiptTime)}
                  </div>
                  <div>{item?.paymentType || "-"}</div>
                  <div>{item?.paymentMethod || "-"}</div>
                  <div>
                    ₹ {Number(item?.paymentAmount || 0).toLocaleString("en-IN")}
                  </div>
                  <div
                    style={{
                      color: getStatusColor(item?.status),
                      fontWeight: 600,
                    }}
                  >
                    {item?.status || "-"}
                  </div>
                </li>
              ))
            ) : (
              <div
                style={{
                  textAlign: "center",
                  padding: "20px",
                  color: mode ? "#FFFFFF" : "#646B88",
                }}
              >
                No receipt data available
              </div>
            )}
          </div>
        </ul>

        {/* Summary */}
        {data?.length > 0 && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "10px",
              marginTop: "12px",
            }}
          >
            <div
              style={{
                background: mode ? "#2C2E33" : "#F8FAFC",
                border: mode ? "1px solid #3A3D45" : "1px solid #E5E7EB",
                borderRadius: "8px",
                padding: "10px",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  color: mode ? "#A1A1AA" : "#6B7280",
                  marginBottom: "4px",
                }}
              >
                Total Amount
              </div>

              <div
                style={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: mode ? "#FFFFFF" : "#111827",
                }}
              >
                ₹ {total.toLocaleString("en-IN")}
              </div>
            </div>

            <div
              style={{
                background: mode ? "#2C2E33" : "#F0FDF4",
                border: "1px solid #22C55E",
                borderRadius: "8px",
                padding: "10px",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  color: "#16A34A",
                  marginBottom: "4px",
                }}
              >
                Paid Amount
              </div>

              <div
                style={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#16A34A",
                }}
              >
                ₹ {paidAmount.toLocaleString("en-IN")}
              </div>
            </div>

            <div
              style={{
                background: mode ? "#2C2E33" : "#FFF7ED",
                border: "1px solid #F59E0B",
                borderRadius: "8px",
                padding: "10px",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  color: "#D97706",
                  marginBottom: "4px",
                }}
              >
                Pending Amount
              </div>

              <div
                style={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#D97706",
                }}
              >
                ₹ {pendingAmount.toLocaleString("en-IN")}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdvanceAmountModalInfo;
